import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const McpOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const errorMessage = searchParams.get('message');
  const integrationId = searchParams.get('integrationId') ?? undefined;
  const providerKey = searchParams.get('providerKey') ?? undefined;

  useEffect(() => {
    if (window.opener) {
      const targetOrigin = window.location.origin;
      window.opener.postMessage(
        {
          type: 'mcp_oauth_completed',
          success: success === '1',
          error: errorMessage ?? undefined,
          integrationId,
          providerKey,
        },
        targetOrigin,
      );
    }
    window.close();
  }, [success, errorMessage, integrationId, providerKey]);

  return null;
};

export default McpOAuthCallback;
